import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { api } from '../httpClient';
import { errorText } from '../errorHandling';

export function useRemote(path) {
  const [state, setState] = useState({ path, data: null, error: '', loading: Boolean(path) });
  const [version, setVersion] = useState(0);
  // React state setters are stable; updater arguments are local, not dependencies.
  const reload = useCallback(() => setVersion(current => current + 1), []);

  useEffect(() => {
    const controller = new AbortController();
    setState({ path, data: null, error: '', loading: Boolean(path) });
    if (!path) return () => controller.abort();

    async function load() {
      try {
        const { data } = await api.get(path, { signal: controller.signal });
        if (!controller.signal.aborted) setState({ path, data, error: '', loading: false });
      } catch (error) {
        if (controller.signal.aborted || axios.isCancel(error)) return;
        setState({ path, data: null, error: errorText(error), loading: false });
      }
    }
    load();
    return () => controller.abort();
  }, [path, version]);

  if (state.path !== path) return { data: null, error: '', loading: Boolean(path), reload };
  return { ...state, reload };
}